import { useNavigate } from 'react-router-dom'
import { useAuth0 } from "@auth0/auth0-react"
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { SaveIcon } from '../../images/Icons'
import { addPartyEventAsync, selectPartyEventsStatus } from './partyEventsSlice'
import '../../App.css'
import { selectCurrentPartyEvent } from '../currentPartyEvent/currentPartyEventSlice'
import { sanitizeEmail } from '../../utils/emailUtils'

export function SavePartyEventButton() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const partyEventsStatus = useAppSelector(selectPartyEventsStatus)

    return (
        <div className='iconButton' onClick={async () => {
            if (currentPartyEvent != null) {
                if (!currentPartyEvent.title) {
                    alert('Title not set')
                    return
                }
                if (!currentPartyEvent.location) {
                    alert('Location not set')
                    return
                }
                if (isAuthenticated && user?.email) { 
                    const accessToken = await getAccessTokenSilently({ authorizationParams : {
                    }})
                        dispatch(addPartyEventAsync( { 
                            partyEvent: currentPartyEvent,
                            token: accessToken,
                            userEmail: sanitizeEmail(user?.email)
                            }))
                        if (partyEventsStatus === 'idle') {
                            navigate(-1)
                        } else {
                            alert (`Not expected status '${ partyEventsStatus }'`)
                        }
                }
            }    
        }}>
            <SaveIcon />
        </div>
    )
}